import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { InventoryTieOutReport } from '../interfaces/inventory/inventoryTieOut.interface';

export const InventoryReportService = {
  tieOut: async (institutionId: string, asOf: string, from: string): Promise<InventoryTieOutReport> =>
    (await axios.get(`${ENDPOINTS.INVENTORY_REPORT.TIE_OUT(institutionId)}?asOf=${asOf}&from=${from}`)).data,
};
